@if(neighborhoodService.currentNeighborhood) {
  <div class="container-fluid pt-4">
    <div class="row">

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Módulos
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Llavero digital
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.digitalKeychainModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Paquetería
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.packageModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Mascotas
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.petModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Encuestas
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.surveysModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Reservaciones
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.bookingsModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Estado de cuenta
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.billingStatementModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Chat con vigilancia
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.chatModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Reportes
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.reportsModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Amonestaciones
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.noticeViolationModule"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row">
          <div class="col d-flex align-items-center">
            Módulo de IA para visitas
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.aiModuleVisits"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

      </div>

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Accesos directos
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Avisos
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.announcementsShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Mis accesos
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.myAccessShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Llavero digital
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.digitalKeychainShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Paquetería
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.packagesShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Mascotas
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.petShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Encuestas
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.surveysShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            SOS
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.sosShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            Reservaciones
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.bookingsShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

        <div class="row">
          <div class="col d-flex align-items-center">
            Reportes
          </div>
          <div class="col-auto text-end d-flex align-items-center justify-content-end">
            <p-inputSwitch
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.reportsShortcut"
              (onChange)="update()"></p-inputSwitch>
          </div>
        </div>

      </div>

    </div>
  </div>
}
